import React from 'react';

import s from './styles.module.scss';
import { fieldTypeComponents } from './field-type-components';

import type { ReadingTemplateRoles } from 'infrastructure/enums';
import type { FormikProps } from 'formik';
import type { FC } from 'react';
import type {
  TFormItem,
  FieldValueMap,
  TFieldProps,
  TFormsReadingType,
  TFormReadingStatus,
  TFormItemName,
  TTemplateRoleData,
} from '../types';

function renderField<K extends keyof FieldValueMap>(
  type: K,
  props: TFieldProps<K>,
) {
  return fieldTypeComponents[type](props);
}

interface FormItemProps {
  item: TFormItem;
  formik: FormikProps<TTemplateRoleData[ReadingTemplateRoles]>;
  readingType: TFormsReadingType;
  readingStatus: TFormReadingStatus;
}

const FormItem: FC<FormItemProps> = ({
  item,
  formik,
  readingType,
  readingStatus,
}) => {
  const { values, setFieldValue } = formik;

  if (item.type === 'info') {
    return <div className={s.wrapper}>{item.html}</div>;
  }

  type TName = TFormItemName<typeof readingStatus, typeof readingType>;
  const formValues = !values[readingStatus]
    ? undefined
    : values[readingStatus]?.[readingType];
  const value = formValues?.[item.name as TName] as any;
  const isTitleValid = React.isValidElement(item.title);

  const onChange = (val: FieldValueMap[typeof item.type]) => {
    const key = `${readingStatus}.${readingType}.${item.name}`;
    setFieldValue(key, val);
  };

  return (
    <>
      <div className={s.wrapper}>
        {isTitleValid && (
          <div className={s['title-wrapper']}>
            {item.title} {item.required && <span>*</span>}
          </div>
        )}
        {renderField(item.type, {
          item,
          value,
          onChange,
          formik,
          readingStatus,
          readingType,
          form: 'normal-risk',
        })}
      </div>
      {item?.items?.map((i) => (
        <FormItem
          item={i}
          key={i.key}
          formik={formik}
          readingStatus={readingStatus}
          readingType={readingType}
        />
      ))}
    </>
  );
};
export default FormItem;
